import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { color, units, variant } from "@m/alchemy-theme";
import { Button } from "../button/Button";
import { ArrowRightIcon } from "../icons/ArrowRightIcon";
import { LoadingIndicator as BaseLoadingIndicator } from "../progress/loading-indicator/LoadingIndicator";
export const ArrowButton = styled(Button) `
  width: ${units(4)};
  flex-shrink: 0;
  margin: ${units(3)};
  height: ${units(4)};
  padding: 0;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
  /* Shrink for smaller browser widths */
  transform: scale(0.75);
  @media (min-width: 720px) {
    transform: scale(1);
  }
  [data-whatinput="keyboard"] &:focus {
    opacity: 1;
  }
`;
export const OverflowScroller = styled.div `
  max-width: 100%;
  max-height: 100%;
  height: inherit;
  width: inherit;
  position: relative;
  overflow: hidden;

  &:hover {
    ${ArrowButton} {
      opacity: 1;
    }
  }
`;
export const ScrollContainer = styled.div `
  overflow: auto;
  position: relative;
  display: flex;
  will-change: scroll-position;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  height: 100%;
  width: 100%;
  max-height: inherit;
  max-width: inherit;

  > div {
    flex-grow: 1;
  }
`;
/* Indicator */
export const Indicator = styled.div `
  ${(props) => css `
    position: absolute;
    display: flex;
    align-items: ${props.align};
    justify-content: center;
    pointer-events: none;
    visibility: ${props.isVisible ? "visible" : "hidden"};
    opacity: ${props.isVisible ? "1" : "0"};
    transition:
      opacity 0.15s ease-in-out,
      visibility 0.15s ease-in-out;
    z-index: ${props.zIndexBase + 2};

    ${ArrowButton} {
      pointer-events: ${props.isVisible ? "all" : "none"};
    }

    @media print {
      display: none;
    }

    [data-whatinput="keyboard"] &:focus-within ${ArrowButton} {
      opacity: 1;
    }

    ${variant("scrollDirection", {
    right: css `
        right: ${props.scrollBarWidth}px;
        width: ${units(6)};
        bottom: ${props.scrollBarHeight}px;
        top: 0;
        padding-top: ${props.offsetY}px;
        background: linear-gradient(90deg, ${color("container", { opacity: 0 })}, ${color("container")});
      `,
    down: css `
        bottom: ${props.scrollBarHeight}px;
        left: 0;
        right: ${props.scrollBarWidth}px;
        height: ${units(6)};
        background: linear-gradient(${color("container", { opacity: 0 })}, ${color("container")});
      `,
    left: css `
        left: 0;
        width: ${units(6)};
        bottom: ${props.scrollBarHeight}px;
        top: 0;
        padding-top: ${props.offsetY}px;
        background: linear-gradient(-90deg, ${color("container", { opacity: 0 })}, ${color("container")});
      `,
    up: css `
        top: 0;
        left: 0;
        right: ${props.scrollBarWidth}px;
        height: ${units(6)};
        background: linear-gradient(0deg, ${color("container", { opacity: 0 })}, ${color("container")});
      `
})}
  `}
`;
export const ArrowIcon = styled(ArrowRightIcon) `
  position: relative;
  ${variant("scrollDirection", {
    right: css `
      transform: rotate(0deg);
    `,
    down: css `
      transform: rotate(90deg);
    `,
    left: css `
      transform: rotate(180deg);
    `,
    up: css `
      transform: rotate(270deg);
    `
})};
`;
export const LoadingIndicator = styled((props) => _jsx(BaseLoadingIndicator, { ...props })) `
  background: ${color("container", { opacity: 0.5 })};
`;
